import { Component, ViewEncapsulation, Directive } from '@angular/core';

/**
 * Content of a card.
 */
@Directive({
  selector: 'pmd-card-body',
  host: {
    class: 'card-body',
  },
  standalone: false,
})
export class PmdCardBody {}

/**
 * Title of a card.
 */
@Directive({
  selector: `pmd-card-title, [pmd-card-title], [pmdCardTitle]`,
  host: {
    class: 'card-title',
  },
  standalone: false,
})
export class PmdCardTitle {}

/**
 * Sub-title of a card.
 */
@Directive({
  selector: `pmd-card-subtitle, [pmd-card-subtitle], [pmdCardSubtitle]`,
  host: {
    class: 'card-subtitle',
  },
  standalone: false,
})
export class PmdCardSubtitle {}

/**
 * card-text of a card.
 */
@Directive({
  selector: `pmd-card-text, [pmd-card-text], [pmdCardText]`,
  host: {
    class: 'card-text',
  },
  standalone: false,
})
export class PmdCardText {}

/**
 * Footer of a card.
 */
@Directive({
  selector: 'pmd-card-footer',
  host: {
    class: 'card-footer',
  },
  standalone: false,
})
export class PmdCardFooter {}

/**
 * Image used in a card.
 */
@Directive({
  selector: '[pmd-media-list], [pmdMediaList]',
  host: { class: 'media' },
  standalone: false,
})
export class pmdMediaList {}

/**
 * Image used in a card.
 */
@Directive({
  selector: '[pmd-card-image], [pmdCardImage]',
  host: { class: 'pmd-card-media' },
  standalone: false,
})
export class PmdCardImage {}

/**
 * Avatar image used in a card.
 */
@Directive({
  selector: '[pmd-card-avatar], [pmdCardAvatar]',
  host: { class: 'pmd-avatar-list-img' },
  standalone: false,
})
export class PmdCardAvatar {}

/**
 * A basic content container component that adds the styles of a pmd material design card.
 */
@Component({
  selector: 'pmd-card',
  exportAs: 'pmdCard',
  templateUrl: 'card.html',
  styleUrls: ['./pmd-card.css'],
  host: { class: 'card pmd-card' },
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class PmdCard {}

/**
 * Component intended to be used within the component. It adds styles for a
 * preset header section (i.e. a title, subtitle, and avatar layout).
 */
@Component({
  selector: 'pmd-card-header',
  templateUrl: 'card-header.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'card-header',
  },
  standalone: false,
})
export class PmdCardHeader {}

/**
 * Component intended to be used within the component. It adds styles for a preset
 * layout that groups an image with a title section.
 */
@Component({
  selector: 'pmd-card-header-media',
  templateUrl: 'card-media.html',
  encapsulation: ViewEncapsulation.None,
  host: { class: 'card-header media' },
  standalone: false,
})
export class PmdCardHeaderMedia {}
